const $ = require("../../node_modules/jquery/dist/jquery.min");

module.exports = {
  init: () => {
    updateSeperators();

    $(window).resize(updateSeperators);

    function updateSeperators() {
      $(".sectionmenu-item").removeClass("sectionmenu-item--last");
      $(".sectionmenu").each(function() {
        var lastElement = false;
        $(this)
          .find(".sectionmenu-item")
          .each(function() {
            if (
              lastElement &&
              lastElement.offset().top != $(this).offset().top
            ) {
              lastElement.addClass("sectionmenu-item--last");
            }
            lastElement = $(this);
          });
      });
    }
  }
};
